// I've seen a few of these BB-8 animations about, so I thought I'd take a shot at building one using React as a bit of an exercise. My favorite thing to do is draw circles around him to make him do a little jig, but I'm easily amused.
import React from "react";
// import style from "./error.css";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

  const logout = () => {
    window.location.href="/admin/dashboard"
  }; 

class App extends React.Component {

    static propTypes = {
        history: PropTypes.object.isRequired
      };    
    constructor(props){
        super(props);

        this.state = {
            droidX: 0,
            mouseX: 0,
            toTheRight: true,
            speed: 6.2,
            accelMod: 1.5
        }
    }
 

    // Keep track of the mouse position.
    handleMouseMove(event) {
        this.setState({
            mouseX: event.pageX
        })
    }

    // Speed Mod Bar
    handleSpeedChange(e) {
        if(parseFloat(e.target.value)) {
            this.setState({
                speed: e.target.value
            })
        }
    }

    // Acceleration Mod Bar
    handleAccelChange(e) {
        if(parseFloat(e.target.value)) {
            this.setState({
                accelMod: e.target.value
            })
        }
    }

    // Get moving!
    movement() {
        let {droidX, mouseX, speed, accelMod} = this.state;

        // Need a pretty strict if statement to make sure React doesn't end up in a 
        // render loop with all the state changes / re-rendering going on.
        if(Math.abs(Math.round(droidX)-mouseX) !== 1){
          
            let distance = mouseX - droidX;
            let acceleration = Math.abs(distance * accelMod) / 100;

            // Move to the right
            if (droidX < mouseX) {
                this.setState({
                    droidX: droidX+(speed*acceleration),
                    toTheRight: true
                });
            }
          
            // Move to the left
            else {
                this.setState({
                    droidX: droidX-(speed*acceleration),
                    toTheRight: false
                });
            }
        }
    }

    // Get some initial movement on first mount. 
    componentWillMount() {
        this.setState({
            mouseX: 300
        });
    }

    // Set up the mouse event listener and fire up the movement function.
    componentDidMount() {
        document.addEventListener('mousemove', (e) => this.handleMouseMove(e));
        setInterval(this.movement.bind(this), 1);
    }
  
    // Clean up.
    componentWillUnmount() {
        document.removeEventListener('mousemove', (e) => this.handleMouseMove(e));
    }

    // Away we go.
    render() {
      let {speed, accelMod, droidX, mouseX, toTheRight} = this.state;
      let {history} = this.props;
      return (         
        <div 
        // style={{
        //     minHeight: "500px",
        //     backgroundImage:
        //       "url(" +
        //       require("../../assets/img/brand/zippy.png").default +
        //       ")",
        //     backgroundSize: "cover",
        //     backgroundPosition: "center top",
        //     alignItems: 'center'
        //           }}        
        >  
<style type="text/css">
    {`
*, *:before, *:after {
    box-sizing: border-box;
  }
  body {
    background: #ffffff;
    overflow: hidden;
  }
  p {
    font-family: 'Roboto', sans-serif;
    font-weight: 100;
    color: #24344c;
  }
  .config p {
    font-size: x-large;
  }
  .config {
    position: relative;
  }
  .control-wrap {
    float: left;
    margin: -15px 15px;
  }
  .logo img {
    position: fixed;
    top: 10px;
    right: 10px;
    width: 70px;
  }
  .bb8 {
    position: absolute;
    margin-left: -70px;
    width: 140px;
    bottom: 15%;
    left: 0;
  }
  .antennas {
    position: absolute;
    transition: left 0.6s;
    left: 28%;
  }
  .antennas.right {
    left: 6%;
  }
  .antenna {
    background: #e0d2be;
    position: absolute;
    width: 2px;
  }
  .antenna.short {
    height: 20px;
    top: -65px;
    left: 50px;
  }
  .antenna.long {
    border-top: 6px solid #020204;
    border-bottom: 6px solid #020204;
    height: 36px;
    top: -80px;
    left: 56px;
  }
  .head {
    background-color: #24344c;
    border-radius: 90px 90px 25px 25px;
    -moz-border-radius: 90px 90px 25px 25px;
    -webkit-border-radius: 90px 90px 25px 25px;
    height: 63px;
    margin-left: -45px;
    overflow: hidden;
    position: absolute;
    width: 104px;
    z-index: 1;
    top: -56px;
    left: 53%;
  }
  .head .stripe {
    position: absolute;
    width: 100%;
  }
  .head .stripe.one {
    background: #7699B7;
    height: 7px;
    opacity: 0.8;
    z-index: 1;
    top: 3px;
  }
  .head .stripe.two {
    background: #CD7640;
    height: 4px;
    top: 14px;
  }
  .head .stripe.three {
    background: #999;
    height: 4px;
    opacity: 0.5;
    bottom: 3px;
  }
  .head .stripe.detail {
    display: flex;
    width: 200px;
    bottom: 7px;
    left: -38%;
    transition: left 0.6s;
  }
  .head .stripe.detail.right {
    left: 0;
  }
  .head .detail {
    height: 7px;
  }
  .head .detail.zero {
    background-color: #CD7640;
    width: 2%;
    margin-left: 3px;
  }
  .head .detail.one {
    background-color: #CD7640;
    width: 8%;
    margin-left: 3px;
  }
  .head .detail.two {
    background-color: #CD7640;
    width: 6%;
    margin-left: 5px;
  }
  .head .detail.three {
    background-color: #CD7640;
    width: 4%;
    margin-left: 45px;
    height: 5px;
    margin-top: 2px;
  }
  .head .detail.four {
    background-color: #CD7640;
    width: 10%;
    margin-left: 4px;
  }
  .head .detail.five {
    background-color: #CD7640;
    width: 2%;
    margin-left: 3px;
  }
  .head .eyes {
    display: block;
    height: 100%;
    position: absolute;
    width: 100%;
    transition: left 0.6s;
    left: 0;
  }
  .head .eyes.right {
    left: 36%;
  }
  .head .eye {
    border-radius: 50%;
    display: block;
    position: absolute;
  }
  .head .eye.one {
    background: #020204;
    border: 4px solid lightgray;
    height: 30px;
    width: 30px;
    top: 12px;
    left: 12%;
  }
  .head .eye.one:after {
    background: #24344c;
    border-radius: 50%;
    content: "";
    display: block;
    height: 3px;
    position: absolute;
    width: 3px;
    top: 4px;
    right: 4px;
  }
  .head .eye.two {
    background-color: lightgrey;
    border: 1px solid #020204;
    height: 16px;
    width: 16px;
    top: 30px;
    left: 40%;
  }
  .head .eye.two:after {
    background: #020204;
    border-radius: 50%;
    content: "";
    display: block;
    height: 10px;
    position: absolute;
    width: 10px;
    top: 2px;
    left: 2px;
  }
  .ball {
    background-color: #24344c;
    border-radius: 50%;
    height: 165px;
    overflow: hidden;
    position: relative;
    width: 165px;
  }
  .lines {
    border: 2px solid #B19669;
    border-radius: 50%;
    height: 400px;
    opacity: 0.6;
    position: absolute;
    width: 400px;
  }
  .lines.two {
    top: -10px;
    left: -250px;
  }
  .ring {
    background: #CD7640;
    border-radius: 50%;
    height: 70px;
    margin-left: -35px;
    position: absolute;
    width: 70px;
  }
  .ring:after {
    background-color: #24344c;
    border-radius: 50%;
    content: "";
    display: block;
    height: 73%;
    margin-top: -36%;
    margin-left: -36%;
    position: absolute;
    width: 73%;
    top: 50%;
    left: 50%;
  }
  .ring.one {
    margin-left: -40px;
    height: 90px;
    width: 100px;
    top: 2%;
    left: 42%;
  }
  .ring.two {
    height: 40px;
    width: 80px;
    -ms-transform: rotate(50deg);
    -webkit-transform: rotate(50deg);
    transform: rotate(50deg);
    top: 65%;
    left: 8%;
  }
  .ring.two:after {
    top: 100%;
  }
  .ring.three {
    height: 37px;
    width: 80px;
    -ms-transform: rotate(-50deg);
    -webkit-transform: rotate(-50deg);
    transform: rotate(-50deg);
    top: 68%;
    left: 84%;
  }
  .ring.three:after {
    top: 110%;
  }
  .shadow {
    background: #3A271C;
    box-shadow: 5px 0 50px #3A271C;
    border-radius: 50%;
    height: 23.3333333333px;
    opacity: 0.25;
    position: absolute;
    width: 140px;
    z-index: -1;
    left: 10px;
    bottom: -8px;
  }
  .instructions p {
    position: fixed;
    bottom: 10px;
    width: 100%;
    text-align: center;
  }
  
    `}
  </style>         
  <div >            
        <span style={{ textAlign: 'center', display: 'block', marginTop: '100px'}}>
          <h2 className="font-semibold text-8xl text-black" style={{textAlign: '-webkit-center'}}>
            <img
          alt="..."
          style={{ width: "165px" }}
          src={require("../../assets/img/zippy.png").default}
        />
            <p>AutomateCIS</p>
          </h2>
          <div >
          {/* <Button color="primary" onClick={() => history.goBack()} size="md">
            {" "}
            Go Back
          </Button> */}

          <Button variant="contained" color="primary" onClick={logout} to="/auth/login" tag={Link}>
            Go Back
          </Button>
        </div>          
     <div class="hero text-center my-0">
        {/* <h1 class="display-1 fw-bold">500</h1> */}
        <Typography variant="h2" gutterBottom component="div">500</Typography>
        <h1 class="display-5 fw-bold">Something Went Wrong.</h1>
        <p class="lead">We're looking to see what happened.<em><span id="display-domain"></span></em>.
        </p>
        {/* <p><btn onclick=javascript:goToHomePage(); class="btn btn-outline-success btn-lg">Go to Homepage</a></btn> */}
    </div>           
    </span>
    </div>                              
          <div className="bb8" style={{WebkitTransform: `translateX(${droidX}px)`}}>
            <div className={'antennas ' + (toTheRight ? 'right' : '')}
                 style={{WebkitTransform: `translateX(${(mouseX - droidX) / 25}px) rotateZ(${(mouseX - droidX) / 80 }deg)`}}>
              <div className="antenna short"></div>
              <div className="antenna long"></div>
            </div>
            <div className="head"
                 style={{WebkitTransform: `translateX(${(mouseX - droidX) / 15}px) rotateZ(${(mouseX - droidX) / 25}deg)`}}>
              <div className="stripe one"></div>
              <div className="stripe two"></div>
              <div className={'eyes ' + (toTheRight ? 'right' : '')}>
                <div className="eye one"></div>
                <div className="eye two"></div>
              </div>
              <div className={'stripe detail ' + (toTheRight ? 'right' : '')}>
                <div className="detail zero"></div>
                <div className="detail zero"></div>
                <div className="detail one"></div>
                <div className="detail two"></div>
                <div className="detail three"></div>
                <div className="detail four"></div>
                <div className="detail five"></div>
                <div className="detail five"></div>
              </div>
              <div className="stripe three"></div>
            </div>
            <div className="ball" style={{WebkitTransform: `rotateZ(${droidX / 2}deg)`}}>
              <div className="lines one"></div>
              <div className="lines two"></div>
              <div className="ring one"></div>
              <div className="ring two"></div>
              <div className="ring three"></div>
            </div>
            <div className="shadow"></div>
          </div>
          
          <div className="instructions">
            <p>www.Zippyops.com</p>
          </div>
          
        </div>
      );
    }
}

export default withRouter(App);